export default "__VITE_ASSET__XzftJUq8__"